import React from 'react'

function ExDataTable({year , extitle , exdesc , exdata}) {
  return (
    <div className='ex-data'>
         <div>
            <p>
                {
                    year
                }
            </p>
         </div>
         <div className='title-col'>
            <h4>
                {
                    extitle
                }
            </h4>
            <span>
                {
                    exdesc
                }
            </span>
         </div>
         <div>
            <p>

                {
                    exdata
                }
            </p>
         </div>
    </div>
  )
}

export default ExDataTable
